export default __webpack_public_path__ + "static/media/direct-tv-tmz-logo.f2947387.svg";